<template>
  <div class="text-textColor overflow-hidden">
    <transition name="fade">
      <div
        v-if="showCreateClaimWorkflow"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full overflow-hidden"
      >
        <form @submit.prevent="submit">
          <div
            class="fixed overflow-y-auto max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-3/5 w-full p-2"
          >
            <transition name="fade">
              <div
                v-if="loading"
                class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
              >
                <loader class="center-h-v" />
              </div>
            </transition>
            <div class="flex justify-between items-center border-b-1.5 p-3">
              <p class="text-base">Create Workflow</p>
              <img
                class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
                src="@/assets/icons/cross-white.png"
                @click="close()"
              />
            </div>
            <transition name="fade">
              <div
                v-if="create_success"
                class="p-1 text-center text-sm w-full bg-green-200"
              >
                {{ create_success }}
              </div>
            </transition>
            <transition name="fade">
              <div
                v-if="create_error"
                class="p-1 text-center text-sm w-full bg-yellow-200"
              >
                {{ create_error }}
              </div>
            </transition>
            <div>
              <div class="grid grid-cols-1 p-4 gap-5">
                <div class="text-sm">
                  <label class="block pb-1"> Name</label>
                  <input
                    v-model="info.Name"
                    type="text"
                    required
                    class="p-2 bg-gray-200 rounded-full w-full"
                  />
                </div>
              </div>

              <div class="grid grid-cols-1 p-4 gap-5">
                <div class="text-sm">
                  <label class="block pb-1">Description</label>
                  <textarea
                    v-model="info.Description"
                    required
                    type="text"
                    class="p-2 bg-gray-200 rounded-md w-full"
                    rows="4"
                    maxlength="500"
                    autocorrect="en-US"
                  ></textarea>
                </div>
              </div>

              <div>
                <div class="p-2">
                  <div class="flex justify-between mb-3">
                    <div class="col-span-1">
                      <label class="block pb-1"
                        >Claim Workflow Group Users</label
                      >
                      <el-select
                        filterable
                        v-model="selectedUser"
                        placeholder="Select a user"
                        class="w-full"
                      >
                        <el-option
                          v-for="employee in getEmployees"
                          :key="employee.Id"
                          :label="
                            decryptDataLocal(employee.Fullname, decryptionKey)
                          "
                          :value="employee.Id"
                        ></el-option>
                      </el-select>
                    </div>
                    <div class="col-span-1">
                      <label class="block pb-1">Sequence</label>
                      <el-input
                        v-model.number="sequenceNumber"
                        type="number"
                        class="w-full"
                      ></el-input>
                    </div>
                    <div class="col-span-1">
                      <label class="block mt-6"></label>
                      <el-button
                        @click="addUserToWorkflow"
                        type="primary"
                        style="background-color: rgba(222, 164, 44)"
                      >
                        Add User
                      </el-button>
                    </div>
                  </div>

                  <el-table
                    :data="workflowUsers"
                    border
                    stripe
                    style="width: 100%"
                  >
                    <el-table-column
                      type="index"
                      label="#"
                      width="50"
                    ></el-table-column>
                    <el-table-column
                      prop="EmployeeName"
                      label="Claim Workflow Group Users"
                      width="auto"
                    ></el-table-column>
                    <el-table-column
                      prop="Sequence"
                      label="Sequence"
                      width="150"
                    ></el-table-column>
                    <el-table-column label="Actions" width="150">
                      <template slot-scope="scope">
                        <el-button
                          @click="removeUser(scope.$index)"
                          type="danger"
                        >
                          Remove
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div class="flex justify-end p-5">
              <button
                type="submit"
                class="bg-primary rounded-full px-10 text-sm text-white py-2"
              >
                Create
              </button>
            </div>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";

import axios from "axios";
import decryptData from "@/utils/decrypt";

let selectedEmployee = "";
const d = [];

export default {
  name: "CompanySetupClaimWorkflowUserGroups",
  // props: ["showCreateClaimWorkflow", "getEmployees", "getWorkflow", "reload"],
  props: ["showCreateClaimWorkflow", "getWorkflow", "reload"],
  components: {
    Loader,
  },
  data() {
    return {
      decryptDataLocal: "",
      decryptionKey: "",
      selectedUser: null,
      sequenceNumber: null,
      locations: [], // add locations data
      newUserGroupMember: null,

      reason: "",
      loading: false,
      departments: [],
      isEditing: false,
      create_success: null,
      create_error: null,
      get_error: null,

      selectedFullname: null,
      selectedEmployees: null,

      workflowUsers: [],

      currentSequence: null,
      info: {
        Name: "",
        Description: "",
        ClaimWorkflowLineRequest: [],
      },

      // submit data
      submitData: [],
      cellSelectionOption: {
        // default true
        enable: false,
      },
      columns: [
        {
          field: "",
          key: "a",
          title: "#",
          width: 50,
          align: "left",

          operationColumn: true,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            row, column, h;
            return ++rowIndex;
          },
        },
        {
          field: "Approver",
          key: "Approver",
          title: "Claim Workflow Group Users",
          align: "left",
          edit: true,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            rowIndex, h, row, column;
            return (
              <el-select
                size="small"
                placeholder="Select"
                filterable
                value={row["Approver"]}
                on-input={(val) => {
                  const selectedEmployee = this.getEmployees.find(
                    (employee) => employee.Id === val.Id
                  );
                  const id = selectedEmployee ? selectedEmployee.Id : null;
                  row["Id"] = id;
                  row["Approver"] = val.Fullname;
                  this.cellDataChange(row, column, val);
                }}
              >
                {this.employeeOptions.map((employee) => {
                  return (
                    <el-option label={employee.Fullname} value={employee} />
                  );
                })}
              </el-select>
            );
          },
        },

        {
          field: "Sequence",
          key: "sequence",
          title: "Sequence",
          align: "center",
          headerAlign: "right",
          edit: true,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            rowIndex, h;
            return (
              <el-input-number
                size="small"
                min={0}
                value={row["Sequence"]}
                on-input={(val) => {
                  row["Sequence"] = val;
                }}
                on-change={(val) => {
                  this.cellDataChange(row, column, val);
                }}
              ></el-input-number>
            );
          },
        },
      ],
      // table data
      tableData: [
        {
          Approver: "",
          Sequence: "",
          Id: "",
        },
      ],
    };
  },

  computed: {
    ...mapGetters(["getOrganization", "getToken", "getEmployees"]),
    employeeOptions() {
      return this.getEmployees;
    },
  },

  created() {
    //console.log(this.getEmployees)
    this.decryptDataLocal = decryptData;
    this.decryptionKey = this.$decryptionKey;
  },
  methods: {
    async addUserToWorkflow() {
      // Check if the user and sequence are selected
      if (this.selectedUser && this.sequenceNumber !== "") {
        // Find the employee by Fullname
        const selectedEmployee = this.getEmployees.find(
          (employee) => employee.Id === this.selectedUser
        );

        // Create a new user group member object
        this.newUserGroupMember = {
          EmployeeId: selectedEmployee.Id,
          Sequence: this.sequenceNumber,
          EmployeeName: decryptData(
            selectedEmployee.Fullname,
            this.decryptionKey
          ),
        };

        this.workflowUsers.push(this.newUserGroupMember);

        this.info.ClaimWorkflowLineRequest.push(this.newUserGroupMember);

        this.selectedUser = "";
        this.sequenceNumber = "";
      }
    },
    removeUser(index) {
      this.workflowUsers = this.workflowUsers.filter((user, i) => i != index);
    },
    async submit() {
      // this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": " application/json",
        },
      };
      try {
        const response = await axios.post(
          `${this.getOrganization}/setup/claim/workflow/${this.$ApiVersion}/create`,
          JSON.stringify(this.info),
          options
        );

        if (response.data.StatusCode == 200) {
          this.create_success = response.data.StatusMessage;
          // Add the new user group member to the workflow

          this.getWorkflow();
          this.workflowUsers = this.workflowUsers.push(this.newUserGroupMember);

          setTimeout(() => {
            this.create_success = null;
            this.reload();
          }, 2000);
        } else {
          this.create_error = response.data.StatusMessage;
          setTimeout(() => {
            this.create_error = null;
          }, 2000);
        }
      } catch (error) {
        this.create_error = error.message;
        setTimeout(() => {
          this.create_error = null;
        }, 2000);
      }
    },
    isEmpty(obj) {
      //console.log(obj);
      return Object.keys(obj).every((key) => obj[key].trim() === "");
    },

    close() {
      this.$emit("close");
      this.tableData = [
        {
          Approver: "",
          Sequence: "",
          Id: "",
        },
      ];
    },
    setSelectedFullname(id) {
      selectedEmployee = this.getEmployees.find(
        (employee) => employee.Id === id
      );
      //console.log(selectedEmployee.Id)
      d.push(selectedEmployee);
      //console.log(filtered)
      return selectedEmployee.Fullname;
    },
    getEmployeeId(id) {
      const userIsNotPresent = this.info.ClaimWorkflowLineRequest.some(
        (user) => user.EmployeeId === id
      );
      const sequenceIsNotPresent = this.info.ClaimWorkflowLineRequest.some(
        (seq) => seq.Sequence === this.currentSequence
      );
      if (!userIsNotPresent && !sequenceIsNotPresent) {
        this.info.ClaimWorkflowLineRequest.push({
          EmployeeId: id,
          Sequence: this.currentSequence,
        });
      } else {
        this.create_error = "Sequence or User already exists in the workflow";
      }
    },
    // cell data change
    cellDataChange(row, column, cellValue) {
      const { submitData } = this;
      let currentCell = submitData.find(
        (x) => x.rowKey === row["rowKey"] && x.field === column.field
      );

      if (currentCell) {
        currentCell.value = cellValue;
      } else {
        let newCell = {
          rowKey: row["rowKey"],
          field: column.field,
          value: cellValue,
        };
        this.submitData.push(newCell);
      }
      // //console.log(selectedEmployee)

      if (row.Sequence) {
        //console.log(row)
        this.info.ClaimWorkflowLineRequest.push({
          EmployeeId: row.Id,
          Sequence: row.Sequence,
        });
        //console.log(this.info)
        if (!this.isEmpty(this.tableData[this.tableData.length - 1])) {
          this.tableData.push({
            Approver: "",
            Sequence: "",
            Id: "",
          });
        }
      }
    },

    getEmployeeById(EmployeeId) {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/${EmployeeId}/general/${this.$ApiVersion}/info`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              //console.log(response.data);
              // //console.log(this.employees)
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    // /{organization}/setup/claim/workflow/v1/create
    create() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };

      axios
        .post(
          `${this.getOrganization}/setup/claim/workflow/${this.$ApiVersion}/create`,
          JSON.stringify(this.info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.create_success = response.data.StatusMessage;
              this.$emit("closeOnSuccess");
              this.selectedEmployees = [];
              setTimeout(() => {
                this.create_success = null;
                this.close();
                this.getWorkflow();
              }, 2000);
            } else {
              this.create_error = response.data.StatusMessage;
              setTimeout(() => {
                this.create_error = null;
              }, 2000);
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
            setTimeout(() => {
              this.create_error = null;
            }, 2000);
          }
        );
    },
    // /{organization}/setup/leave/workflow/group/v1/edit
    editWorkflow() {
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      //console.log(d);
      const data = {};

      axios
        .put(
          `${this.getOrganization}/setup/leave/workflow/group/${this.$ApiVersion}/edit`,
          JSON.stringify(data),
          options
        )
        .then((response) => {
          if (response.data.StatusCode == 200) {
            this.getLocations();
          }
        });
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
